import React from "react";
import { Box, Button, Typography } from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import CategoryControl from "./CategoryControl";

/**
 * A tab whose card is Step 3's Duplicate: it reuses another platform's video,
 * so there is nothing to edit here. Read-only, with a way to that platform and
 * a way back to an edit of its own.
 */
export default function DuplicatePane({ item, onOpenSource, onEditSeparately, onCategoryChange, onExtraChange }) {
  const from = item.config?.duplicateOf;
  return (
    <Box flex={1} display="flex" alignItems="center" justifyContent="center" p={3}>
      <Box
        sx={{
          maxWidth: 460,
          textAlign: "center",
          p: 3,
          borderRadius: 3,
          border: "1px solid #e2e8f0",
          bgcolor: "white",
          boxShadow: "0 1px 3px rgba(30,32,90,.06), 0 8px 22px rgba(43,42,140,.09)",
        }}
      >
        <ContentCopyIcon sx={{ fontSize: 30, color: "#059669", mb: 1 }} aria-hidden />
        <Typography variant="subtitle1" fontWeight={700} gutterBottom>
          {item.platform} duplicates {from}
        </Typography>
        {onCategoryChange && (
          <Box display="flex" justifyContent="center" mb={2}>
            {/* Its own category: a duplicate shares the video, not the category. */}
            <CategoryControl item={item} onChange={onCategoryChange} onExtraChange={onExtraChange} size="panel" />
          </Box>
        )}
        <Typography variant="body2" color="text.secondary" mb={2.5}>
          {item.platform} publishes the same video as {from} — no separate edit or render. Changes to {from} carry over automatically. Step 3
          shows it as <strong>Duplicate → {from}</strong>.
        </Typography>
        <Box display="flex" gap={1} justifyContent="center" flexWrap="wrap">
          <Button variant="contained" onClick={onOpenSource} sx={{ textTransform: "none", fontWeight: 700, borderRadius: 1.5, background: "linear-gradient(135deg, #312e81, #4338ca)" }}>
            Open {from}
          </Button>
          <Button variant="outlined" onClick={onEditSeparately} sx={{ textTransform: "none", fontWeight: 600, borderRadius: 1.5 }}>
            Edit {item.platform} separately
          </Button>
        </Box>
      </Box>
    </Box>
  );
}
